/**
 * Member Service
 * 
 * This service handles all member-related API calls.
 */

import { publicApiClient } from './apiClient';
import API from '../config/api';
import logger from '../utils/logger';

// Create logger instance for member service
const memberLogger = logger.create('MemberService');

const memberService = {
  /**
   * Check if a person is a member by national ID
   * @param {string} nationalId - The national ID to check
   * @returns {Promise<Object>} - Membership check response
   */
  async checkMembership(nationalId) {
    try {
      memberLogger.info('Checking membership for national ID', { nationalId });
      
      const response = await publicApiClient.get(API.members.checkMembership(nationalId));
      
      memberLogger.info('Membership check completed', { 
        nationalId, 
        isMember: response.data.is_member 
      });
      
      return response.data;
    } catch (error) {
      memberLogger.error('Failed to check membership', { 
        nationalId, 
        error: error.message 
      });
      throw error;
    }
  }
};

export default memberService;
